import { Badge } from '../ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const AdminPaymentsTab = ({ payments }) => (
  <Card>
    <CardHeader>
      <CardTitle>Facturation mensuelle ({payments.length})</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b">
              <th className="text-left py-3 px-4 font-medium text-muted-foreground">Mois</th>
              <th className="text-left py-3 px-4 font-medium text-muted-foreground">Utilisateur</th>
              <th className="text-left py-3 px-4 font-medium text-muted-foreground">Communauté</th>
              <th className="text-center py-3 px-4 font-medium text-muted-foreground">Type</th>
              <th className="text-right py-3 px-4 font-medium text-muted-foreground">Énergie (kWh)</th>
              <th className="text-right py-3 px-4 font-medium text-muted-foreground">Montant</th>
              <th className="text-center py-3 px-4 font-medium text-muted-foreground">Statut</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p, i) => (
              <tr key={i} className="border-b hover:bg-muted/50">
                <td className="py-3 px-4 font-medium text-sm">{p.month}</td>
                <td className="py-3 px-4">
                  <p className="text-sm font-medium">{p.user_name || '—'}</p>
                  <p className="text-xs text-muted-foreground">{p.user_email || ''}</p>
                </td>
                <td className="py-3 px-4 text-sm text-muted-foreground">{p.community_name || '—'}</td>
                <td className="py-3 px-4 text-center">
                  <Badge variant="outline" className={p.type === 'revenue' ? 'border-green-200 text-green-700' : 'border-blue-200 text-blue-700'}>
                    {p.type === 'revenue' ? 'Revenu (prod.)' : 'Facture (conso.)'}
                  </Badge>
                </td>
                <td className="py-3 px-4 text-right text-sm">{p.energy_kwh?.toFixed(1)}</td>
                <td className="py-3 px-4 text-right font-medium">
                  {p.type === 'revenue' ? '+' : '-'}{p.amount_eur?.toFixed(2)}€
                </td>
                <td className="py-3 px-4 text-center">
                  <Badge className={p.status === 'paid' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'}>
                    {p.status === 'paid' ? 'Payé' : 'En attente'}
                  </Badge>
                </td>
              </tr>
            ))}
            {payments.length === 0 && (
              <tr><td colSpan={7} className="py-8 text-center text-muted-foreground">Aucune facturation</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);
